module.exports = __webpack_public_path__ + "img/spinner.94f6bcff.gif";